module.exports = __webpack_public_path__ + "img/checkbox_selected.e5c760a3.svg";